module.exports = __webpack_public_path__ + "img/img2.c793dd94.png";